import React, { Fragment } from 'react';
import { CSSProp } from 'styled-components';

import { FormBase, FormJoin } from '@shared/interfaces/form';
import { Subject } from '@shared/enums/subject';
import { MailRow } from '@components/atoms';

function ApplyToJoinEmail<T extends FormJoin & FormBase>({
  lastName,
  firstName,
  dateOfBirth,
  phoneNumber,
  extraInfo,
  hazmatPermit,
  postalCode,
  country,
  subject,
  email,
  state,
}: Omit<T, 'to'>) {
  const subjectStyles: CSSProp = {
    fontSize: '25px',
    textAlign: 'center',
    marginBottom: '30px',
    textDecoration: 'underline',
  };

  const wrapperStyles: CSSProp = {
    border: '1px solid black',
    padding: '25px 10px',
    borderRadius: '12px',
    overflow: 'scroll',
    margin: '0 auto',
    width: '500px',
  };

  const isApplyToJoin = subject === Subject.ApplyToJoin;

  return (
    <div style={wrapperStyles}>
      <div style={subjectStyles}>{subject}</div>

      {isApplyToJoin && (
        <Fragment>
          <MailRow title="First name" value={firstName} />
          <MailRow title="Last name" value={lastName} />
          <MailRow title="Date of birth" value={dateOfBirth} />
          <MailRow title="Phone number" value={phoneNumber} />
          <MailRow title="Email" value={email} />
          <MailRow title="Country" value={country} />
          <MailRow title="State" value={state} />
          <MailRow title="Postal code" value={postalCode} />
          <MailRow title="Hazmat permit" value={hazmatPermit} />
        </Fragment>
      )}

      {!isApplyToJoin && (
        <Fragment>
          <MailRow title="First name" value={firstName} />
          <MailRow title="Last name" value={lastName} />
          <MailRow title="Phone number" value={phoneNumber} />
          <MailRow title="Additional Information" value={extraInfo} />
        </Fragment>
      )}
    </div>
  );
}

export default ApplyToJoinEmail;
